// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1N5we","item":"PaymentsMobile_item__Vw9GT","label":"PaymentsMobile_label__3t1Vp","amount":"PaymentsMobile_amount__1eJB3"};